module.exports = __webpack_public_path__ + "static/media/versace-dylan-blue-big.08055678.png";